export default __webpack_public_path__ + "static/media/overviewBannerMobile.8ae389fc.png";